import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-newsletter-header',
  imports: [],
  templateUrl: './newsletter-header.component.html',
  styleUrl: './newsletter-header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterHeaderComponent {}
